<template>
  <div o-Container>
    <!--    <vo-app-menu-buildingeo-player ref="videoPlayer" class="video-player vjs-custom-skin"-->
    <!--                  :playsinline="true"-->
    <!--                  :options="playerOptions"/>-->
    <o-list v-bind:source="list.sensor" v-bind="{searched:search}"/>
  </div>
</template>


<script>
  export default {
    name: "admin_Dashboard", /* 这个name暂时不知道用啥用，根据官方文档说的是方便排错的 */
    data() {
      return {
        octopus: this.$parent.octopus,
        list: {
          sensor: {
            data: {
              id: 131, // 菜单表的八爪鱼ID
              cellData: [
                {name: "TypeID", width: 70, searchKey: "="},
                {name: "Title", width: 180, searchKey: "="},
                {name: "Content", width: 800},
                {name: "CreateUserID", width: 100},
                {name: "CreateTime", width: 130},
              ],
            }
          },
        },
        // playerOptions: {
        //   playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        //   autoplay: false, //如果true,浏览器准备好时开始回放。
        //   controls: true, //控制条
        //   preload: 'auto', //视频预加载
        //   muted: false, //默认情况下将会消除任何音频。
        //   loop: false, //导致视频一结束就重新开始。
        //   language: 'zh-CN',
        //   aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        //   fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        //   sources: [{
        //     type: 'application/x-mpegURL',
        //     src: 'http://livepull1.uniview.com/live/210235c55b3214000032000009715340.m3u8?txTime=60CAEB93&txSecret=1b2e266e58e813ab6cb507446edff372&codec=264'
        //   }],
        //   poster: "https://api.smart.aaa.com/api/upload/20201010/84afd5fe-8fbb-4935-97cc-802cc872d684", //你的封面地址
        //   width: document.documentElement.clientWidth,
        //   notSupportedMessage: '此视频暂无法播放，请稍后再试' //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        // },
      }
    },
    created: function () {
      this.init();
    },
    methods: {
      init: function () {
        // this.octopus.request.api.post("/ESB/Services/Tools/Data/Get", {
        //   requestType: "POST_JSON", // POST_JSON
        //   url: "https://api.solarmanpv.com/account/v1.0/token?appId=2023011072841508",
        //   params: {
        //     appSecret: "337f508e3c61dfdc6d66a1e5e59c31a0",
        //     username: "wxzhkj2022",
        //     password: "0edcc79d7240eb9c177322a38a214c33b4041bc25a9e149ed6cfafe24eef1c44"
        //   },
        //   // headers: "",
        //   // responseType: 1 // RETURN JSON
        // }, function (apiData) {
        //   console.warn(apiData);
        //   // alert(JSON.stringify(apiData));
        // });

        // // 海康
        // let httpParams = {
        //   url: "https://open.ys7.com/api/lapp/token/get",
        //   params: {
        //     appKey: "97e58c72d2cd4af6b2861a44d1608c35",
        //     appSecret: "e121d511123963f215f253c036b733ca"
        //   },
        // };
        // this.octopus.request.api.post("/ESB/Services/Tools/Data/Get", httpParams, function (data) {
        //   // alert(JSON.stringify(data.content.response));
        //   if (data.status.code == 200) {
        //     let hkData = data.content.response;
        //     alert(JSON.stringify(hkData));
        //   }
        // });

        // SMS 测试
        if (false) {
          let smsData = {
            // 用户ID
            userList: [2, 3, 1765],
            paramList: {
              order: "cbx_24090300001",
              code: "711911"
            },
            templateID: "5" // 权益模版
          };
          this.octopus.push.sms(smsData, function (data) {
            alert(JSON.stringify(data));
          });
        }
      },
      create: function () {
        this.octopus.router.jump("/MMS/Cluster/Build/Modify");
      },
      output: function (data) {
        // 导出以后，回调这里给客户端操作。
        // 核心思想是cellData包含search数据（不管有没有），回传以后发送export指令，后台api会直接返回导出的数据提供下载。
        alert("export: get cell data is " + JSON.stringify(data));
      },
      search: function (cell) {

      },
      modify: function (row) {

      },
      view: function (row) {
        alert("view key: " + JSON.stringify(row));
      },
      del: function (row) {
        alert("del key: " + JSON.stringify(row));
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Main/Platform/Dashboard/Page.vue